import * as types from '@/store/mutation-types';
import Vue from 'vue';

export default {
  [types.setInspectionProperties](_state, update) {
    Object.assign(update.updateInspection, update.newInspectionProperties);
  },

  [types.addInspection](state, { inspection }) {
    if (!state.selectedPart || state.selectedPart._id !== inspection.partId) {
      return;
    }
    Vue.set(state, 'selectedPartInspection', inspection);
  },

  [types.addInspectionParticipant](_state, { updateInspection, participant }) {
    const index = updateInspection.participants.findIndex(({ personId }) => personId === participant.personId);
    updateInspection.participants.splice(index, index >= 0 ? 1 : 0, participant);
  },

  [types.setSelectedPartInspection](state, inspection) {
    Vue.set(state, 'selectedPartInspection', inspection);
  },
};



// WEBPACK FOOTER //
// ./src/store/inspection/inspectionMutations.js